import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { RateCard } from '../../../shared/types/rateCard';

interface RateCardListProps {
  rateCards: RateCard[];
  onEdit: (rateCard: RateCard) => void;
  onDelete: (rateCard: RateCard) => void;
  onCreate: () => void;
  loading?: boolean;
}

const RateCardList: React.FC<RateCardListProps> = ({
  rateCards,
  onEdit,
  onDelete,
  onCreate,
  loading = false,
}) => {
  const getCurrencySymbol = (currency: string) => {
    switch (currency) {
      case 'USD': return '$';
      case 'EUR': return '€';
      case 'GBP': return '£';
      case 'BRL': return 'R$';
      default: return '$';
    }
  };


  return (
    <div className="bg-white rounded-lg shadow border border-gray-200">
      <div className="flex items-center justify-between p-6 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-900">Rate Cards</h2>
        <button
          onClick={onCreate}
          className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          <FontAwesomeIcon icon={faPlus} />
          <span>New Rate Card</span>
        </button>
      </div>

      <div className="p-6">
        {rateCards.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-gray-500 mb-4">No rate cards found</p>
            <button
              onClick={onCreate}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              Create your first rate card
            </button>
          </div>
        ) : (
          <div className="space-y-4">
            {rateCards.map((rateCard) => (
              <div
                key={rateCard.id}
                className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center justify-between mb-3">
                  <div className="flex-1">
                    <h3 className="font-medium text-gray-900">{rateCard.title}</h3>
                    <p className="text-sm text-gray-500">
                      {rateCard.roles.length} role{rateCard.roles.length !== 1 ? 's' : ''} • {rateCard.currency}
                    </p>
                  </div>
                  <div className="flex items-center space-x-2">
                    <button
                      onClick={() => onEdit(rateCard)}
                      className="p-2 text-gray-400 hover:text-blue-600 transition-colors"
                      title="Edit rate card"
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                      onClick={() => onDelete(rateCard)}
                      className="p-2 text-gray-400 hover:text-red-600 transition-colors"
                      title="Delete rate card"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </div>
                </div>

                <div className="space-y-2">
                  {rateCard.roles.map((role) => (
                    <div key={role.id} className="flex items-center justify-between py-2 px-3 bg-gray-50 rounded-md">
                      <span className="text-sm font-medium text-gray-700">{role.title}</span>
                      <span className="text-sm text-gray-600">
                        {getCurrencySymbol(rateCard.currency)}{role.dailyRate.toLocaleString()}/day
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RateCardList;
